import { useSiteContext } from "./useSiteContext"

export function useFreeShippingThreshold() {
    const { setState } = useSiteContext()

    function setFreeShippingThreshold(value: any) {
        setState((prevState: any) => {
            return {
                ...prevState,
                freeShippingThreshold: value,
            }
        })
    }
    return setFreeShippingThreshold
}